import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { realtorConstants, realtorModels } from '..';

export const useRealtorBalanceCard = () =>
  useQuery<realtorModels.IRealtorBalanceCard>({
    queryKey: [realtorConstants.queryKeys.REALTOR_BALANCE_CARD],
    queryFn: async () => {
      const res = await $api.get('/v1/realtor/balance/card');

      return res?.data?.data;
    }
  });
